import ReportsPopover, {ReportsPopoverExtensionProps} from 'modules/reports/components/Popover'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsSchedulePopover.styles'

type Props = ReportsPopoverExtensionProps & {}

function ReportsSchedulePopover(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'popovers', 'Schedule')

  return (
    <ReportsPopover {...props} data-testid={p()}>
      <div className={classes.root}>{pt('title')}</div>
    </ReportsPopover>
  )
}

export default ReportsSchedulePopover
